import { Outlet } from 'react-router-dom'
import Navigation from './Navigation'
import { useState } from 'react';
import { classNames } from '../../style/common';
import { NavigationContext } from '../../components/Navigation/NavigationContext';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { AppState } from '../../appSlice';
import { AppProgress } from '../../components/Progress/AppProgress';
import { Discord } from '../../components/Discord/Discord';
import { KoFiIcon } from '../../components/Icons/KoFiIcon';
import { XIcon } from '../../components/Icons/XIcon';

export function ChocoShell() {
  const [isNavOpen, setIsNavOpen] = useState(true);
  const {
    isRawCardVariantsLoading,
    isRawCardsLoading,
    isJobsLoading,
    isCategoriesLoading,
    isProductsLoading,
    isArtistsLoading
  } = useSelector<RootState, AppState>(state => state.app);

  return (
    <div>
      <NavigationContext.Provider value={{ isNavOpen: isNavOpen, setIsNavOpen: setIsNavOpen }}>
        <Navigation />

        <main className={classNames("pt-[56px]", isNavOpen ? "lg:pl-72" : "")}>
          <div className='flex flex-col min-h-screen justify-between' style={{ minHeight: "calc(100vh - 56px)" }}>
            <div>
              {
                (isRawCardVariantsLoading || isRawCardsLoading || isJobsLoading || isCategoriesLoading || isArtistsLoading || isProductsLoading)
                  ? <div className='p-8'><AppProgress showCardVariants={true} showCards={true} showJobs={true} showCategories={true} showArtists={true} showProducts={true} /></div>
                  : <Outlet />
              }
            </div>
            <div className='text-sm text-center py-4 text-contrast-tertiary pb-24 md:pb-6'>
              <div>FINAL FANTASY is a registered trademark of Square Enix Holdings Co., Ltd.</div>
              <div className='flex justify-center items-center gap-4'>
                <a href="https://discord.gg/mAErry4jUf" target='_blank'>
                  <Discord classNames={{ svg: "h-5 w-5", path: "fill-contrast-tertiary" }} />
                </a>
                <a href="https://x.com/materiahunter_" target='_blank'>
                  <XIcon classNames={{ svg: "h-4 w-4", path: "fill-contrast-tertiary" }} />
                </a>
                <a href="https://ko-fi.com/materiahunter" target='_blank'>
                  <KoFiIcon classNames={{ svg: "h-5 w-5", path: "fill-contrast-tertiary" }} />
                </a>
              </div>
            </div>
          </div>
        </main>
      </NavigationContext.Provider>
    </div>
  )
}